<!-- 添加/修改植被，bluesky:2023-10-05 -->
<template>
  <div class="add-or-edit-section">
    <el-form :label-position="'right'" label-width="100px" :model="formData" :rules="rules" ref="form">
        <el-form-item label="名称:" prop="name">
            <el-input v-model="formData.name" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="类型:" prop="type">
          <el-select @change="changeType" v-model="formData.type" placeholder="请选择">
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="适宜种植月份:">
          <el-checkbox-group v-model="formData.suitableMonthList" @change="changeMonthList">
            <el-checkbox
            v-for="(item,index) in 12" :key="index"
            :label="item" :value="item">{{item}}月</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="说明:">
            <el-input type="textarea" v-model="formData.description" placeholder="请输入"></el-input>
        </el-form-item>

        <div>
          <div slot="footer" class="dialog-footer-in-form">
            <el-button plain @click="close">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
          </div>
        </div>

    </el-form>
  </div>
</template>

<script>
export default {
    props:{
        idInput:null,
    },
    created(){
    	this.formData.id = this.idInput;
    	//如果idInput不为空，表示修改
    	if(this.idInput && this.idInput != null){
    		this.getItem();
    	}
    },

    data(){
        return {
            formData: {
              id:null,// 植被ID
              name:null,// 植被名称
              type:null,// 类型（0=树种，1=草种）
              suitableMonthList:[],// 适宜种植月份（月份数字用英文逗号连接）
              status:1,// 状态
            },
            rules:{
                name:{required:true,message:'名称不能为空',trigger:'blur'},
                type:{required:true,message:'类型不能为空',trigger:'blur'},
            },
            typeList:[{
              name:'请选择',
              value:null
            },{
              name:'树种',
              value:0
            },{
              name:'草种',
              value:1
            }],
        }
    },
    methods:{
      // 改变类型
      changeType(){

      },
      // 改变月份
      changeMonthList(){

      },
      getItem(){
        this.$apis.get('/admin/tree/get', {
          id:this.formData.id
        }).then(res => {
          if(res.data.code == 200){
            this.formData = res.data.data;
            if(res.data.data.suitableMonthList){
              let tmpStr = res.data.data.suitableMonthList;
              console.log("tmpStr",tmpStr);
              let list = [];
              tmpStr.split(',').forEach(x => {
                if(x && x != ""){
                  list.push(parseInt(x));
                }
              });
              console.log("list",list);
              this.formData.suitableMonthList = list;
            }
            else{
              this.formData.suitableMonthList = [];
            }
          }
          else{
            this.$message({
              type: 'error',
              message: `${res.data.data}`
            });
          }
        });
      },

      submit(){
        //验证rules
        this.$refs.form.validate(async (valid)=>{
          console.log(valid)
          if(valid){
            let url = this.formData.id && this.formData.id != "" ? "/admin/tree/update" : "/admin/tree/add";
            this.$apis.post(url, this.formData).then(res => {
              if(res.data.code == 200){
                this.formData = res.data.data;
                this.$emit("success");
                this.$message({
                  type: 'success',
                  message: `操作成功！`
                });
              }
              else{
                this.$message({
                  type: 'error',
                  message: `${res.data.data}`
                });
              }
            });
          }
        });
      },
      // 关闭
      close(){
        this.$emit("close");
      },

    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/components/addOrEditTree.vue